<template>
  <div class="single-past_awards-image_upload">

    <v-card>
      <v-img :src="submission['img_url']" aspect-ratio="1.5"></v-img>
      <v-card-actions>
        <AwardsSubmissionRating :submission="submission"
                                :has_comment="has_comment"
                                submission_method="image_upload"
                                @check-comments="check_comments = true"
        />
        <v-spacer></v-spacer>
        <div class="single_awards_action ml-2" v-if="has_comment && show_comments">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="openDialog('comments')">
                <v-icon class="notranslate">comment</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('awards.read_comments') }}</span>
          </v-tooltip>
          <span class="btn_label">{{ $t('comments_label') }}</span>
        </div>
        <div class="single_awards_action ml-2"
             v-if="parseInt(submission['rating'], 10) >= 1">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on"
                     :color="review_info['color']"
                     @click="openDialog((submission['review'] && submission['review']['analysis_status'] === 'done') ? 'read_review' : 'request_review')">
                <v-icon class="notranslate">image_search</v-icon>
              </v-btn>
            </template>
            <span>{{ review_info['text'] }}</span>
          </v-tooltip>
          <span class="btn_label">{{ $t('review_label') }}</span>
        </div>
        <div class="single_awards_action ml-2"
             v-if="(can_dispute && parseInt(submission['rating'], 10) >= 1) || submission['dispute'] !== ''">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on"
                     :color="dispute_info['color']"
                     @click="openDialog((submission['dispute'] && submission['dispute']['analysis_status'] === 'done') ? 'read_dispute' : 'open_a_dispute')">
                <v-icon class="notranslate">report</v-icon>
              </v-btn>
            </template>
            <span>{{ dispute_info['text'] }}</span>
          </v-tooltip>
          <span class="btn_label">{{ $t('dispute_label') }}</span>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import VCard from 'vuetify/es5/components/VCard/VCard'
import VIcon from 'vuetify/es5/components/VIcon/VIcon'
import VImg from 'vuetify/es5/components/VImg/VImg'
import AwardsSubmissionRating from './AwardsSubmissionRating'
import { confirmed_status } from '../utils/rules'
export default {
  name: 'PastAwardsImageUpload',
  components: { AwardsSubmissionRating, VCard, VIcon, VImg },
  props: {
    submission: {
      type: Object,
      required: true
    },
    can_dispute: {
      type: Boolean,
      required: true
    },
    show_comments: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    admin_comment: function () {
      return this.submission['admin_comment']
    },
    judges_comments: function () {
      return Object.values(this.submission['judges_comments']).filter(
        el => el.visible
      ).map(
        el => el.comment
      )
    },
    has_comment: function () {
      return (this.admin_comment !== '' || this.judges_comments.length >= 1)
    },
    review_info: function () {
      if (this.submission['review'] === '') {
        return {
          text: this.$t('awards.request_review'),
          color: 'none'
        }
      } else {
        if (confirmed_status.includes(this.submission['review']['payment_status'])) {
          return (this.submission['review']['analysis_status'] === 'pending')
            ? {
              text: this.$t('review_in_analysis'),
              color: 'info'
            }
            : {
              text: this.$t('review_done'),
              color: 'success'
            }
        } else {
          return {
            text: this.$t('review_payment_not_confirmed'),
            color: 'error'
          }
        }
      }
    },
    dispute_info: function () {
      if (this.submission['dispute'] === '') {
        return {
          text: this.$t('awards.open_a_dispute'),
          color: 'none'
        }
      } else {
        if (confirmed_status.includes(this.submission['dispute']['payment_status'])) {
          return (this.submission['dispute']['analysis_status'] === 'pending')
            ? {
              text: this.$t('dispute_in_analysis'),
              color: 'info'
            }
            : {
              text: this.$t('dispute_done'),
              color: 'success'
            }
        } else {
          return {
            text: this.$t('dispute_payment_not_confirmed'),
            color: 'error'
          }
        }
      }
    }
  },
  methods: {
    openDialog: function (type) {
      if (type === 'read_review') {
        this.$router.push(`/reviews/${this.submission['review']['post_id']}`)
      } else if (type === 'read_dispute') {
        this.$router.push(`/disputes/${this.submission['dispute']['post_id']}`)
      } else {
        if (
          !(type === 'request_review' && this.submission['review'] !== '') &&
          !(type === 'open_a_dispute' && this.submission['dispute'] !== '')
        ) {
          this.$emit('open-dialog',
            type,
            this.$vnode.key,
            this.submission['img_url'],
            this.admin_comment,
            this.judges_comments
          )
        } else {
          const raw_type = type === 'request_review' ? 'review' : 'dispute'
          this.$emit('open-requested-dialog',
            type,
            this.$vnode.key,
            this.submission['thumbnail'],
            this.submission[raw_type]
          )
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .single-past_awards-image_upload {
    width: 100%;
    .single_image {
      width: 100%;
      padding-top: 66.7%;
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
    }
  }
  .comment_quote {
    margin: 12px 0 12px 12px;
    font-size: 16px;
    color: rgba(0,0,0,0.54);
    font-style: italic;
    &::before,
    &::after{
      content: '"';
      font-size: 18px;
      font-weight: bold;
    }
  }
  .comment_quote + .headline {
    margin-top: 12px;
  }
  .v-card__actions .single_awards_action {
    display: flex;
    flex-direction: column;
    align-items: center;
    .v-btn {
      width: 32px;
      height: 32px;
    }
    .btn_label {
      font-size: 12px;
      line-height: 14px;
      color: rgba(0,0,0,0.54);
    }
  }
</style>

<i18n>
  {
    "en": {
      "comments_label": "Comments",
      "review_label": "Review",
      "dispute_label": "Dispute",
      "review_in_analysis": "Review requested, photo in analysis",
      "review_done": "Review completed, read here",
      "review_payment_not_confirmed": "Payment not yet confirmed",
      "dispute_in_analysis": "Dispute requested, photo in analysis",
      "dispute_done": "Dispute completed, read here",
      "dispute_payment_not_confirmed": "Payment not yet confirmed"
    },
    "pt": {
      "comments_label": "Comentários",
      "review_label": "Análise",
      "dispute_label": "Contestação",
      "review_in_analysis": "Análise crítica solicitada, foto em análise",
      "review_done": "Análise crítica concluída, leia aqui",
      "review_payment_not_confirmed": "Pagamento ainda não confirmado",
      "dispute_in_analysis": "Contestação solicitada, foto em análise",
      "dispute_done": "Contestação concluída, leia aqui",
      "dispute_payment_not_confirmed": "Pagamento ainda não confirmado"
    }
  }
</i18n>
